<template>
    <div class="text-center">
        <div :class="mbSmall ? 'mb-4px mb-md-8px' : 'mb-16px mb-md-24px'">
            <div v-if="this.$slots['default']" class="tit tit--sm"><slot /></div>
        </div>
        <p v-if="this.$slots['text']" class="txt txt--xl txt--dark"><slot name="text" /></p>
    </div>
</template>

<script>
export default {
    props: {
        mbSmall: { type: Boolean },
    },
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
